import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AppState } from '@app/reducers';
import {
  BreadCrumbModel, CrudService, CustomDirectiveConfig, DOB_YEAR_TO_CURRENT_YEARS, FILE_ACCEPTS, IApplicationResponse,
  LoggedInUserModel, ModulesBasedApiSuffix,
  ResponseMessageTypes, RxjsService,
  SERVER_REQUEST_DATE_TRANSFORM,
  STANDARD_FILE_FORMATS,
  SnackbarService,
  adjustDateFormatAsPerPCalendar,
  adjustMonthFormatAsPerPCalendar,
  datePipeConversion,
  isValidFilename,
  prepareGetRequestHttpParams,
  setRequiredValidator,
  standardHeightForPscrollContainer
} from '@app/shared';
import { loggedInUserData } from '@modules/others';
import {
  CreditVettingInfo,
  CreditVettingModalComponent, DebtorType, LeadHeaderData,
  SalesModuleApiSuffixModels,
  ServiceAgreementStepsParams,
  selectLeadCreationStepperParamsState$,
  selectLeadHeaderDataState$
} from '@modules/sales';
import { Store, select } from '@ngrx/store';
import { DialogService } from 'primeng/api';
import { combineLatest } from 'rxjs';
@Component({
  selector: 'credit-vetting-info',
  templateUrl: './credit-vetting.component.html',
  styleUrls: ['./service-installation-agreement.scss']
})

export class CreditVettingInfoComponent implements OnInit {
  serviceAgreementStepsParams: ServiceAgreementStepsParams;
  leadHeaderData: LeadHeaderData;
  details;
  creditVettingInfoForm: FormGroup;
  isAnAlphaNumericOnly = new CustomDirectiveConfig({ isAnAlphaNumericOnly: true });
  IsInstallationDebtor: boolean = false;
  loggedInUserData: LoggedInUserModel;
  minDate = new Date();
  successMsg: boolean = false;
  customerId = "";
  debtorId = "";
  debtorAccountDetailId = "";
  breadCrumb: BreadCrumbModel;
  debtorTypeEnum = DebtorType;
  standardHeightForPscrollContainer = standardHeightForPscrollContainer;
  todayDate = new Date();
  yearRange = DOB_YEAR_TO_CURRENT_YEARS;
  fileName: any = {};
  @ViewChild('fileInput', { static: false }) fileInput: any;
  accept: any = FILE_ACCEPTS;
  fileFormats: any = STANDARD_FILE_FORMATS;

  constructor(private crudService: CrudService, public dialogService: DialogService,
    private activatedRoute: ActivatedRoute,
    private store: Store<AppState>, private formBuilder: FormBuilder,
    private snackbarService: SnackbarService,
    private rxjsService: RxjsService, private router: Router) {
    this.combineLatestNgrxStoreData();
  }

  combineLatestNgrxStoreData() {
    combineLatest([
      this.store.select(selectLeadCreationStepperParamsState$),
      this.store.select(selectLeadHeaderDataState$), this.store.pipe(select(loggedInUserData)), this.activatedRoute.queryParams]
    ).subscribe((response) => {
      this.serviceAgreementStepsParams = new ServiceAgreementStepsParams(response[0]);
      this.leadHeaderData = response[1];
      this.loggedInUserData = response[2];
      if (response[3]) {
        this.customerId = response[3].customerId;
        this.debtorId = response[3].debtorId;
        this.debtorAccountDetailId = response[3].debtorAccountDetailId;
      }
    });
  }

  ngOnInit() {
    this.rxjsService.getIsInstallationDebtor().subscribe((IsInstallationDebtor: boolean) => {
      this.IsInstallationDebtor = IsInstallationDebtor;
      this.breadCrumb = {
        pageTitle: { key: 'Credit Vetting' },
        items: [{
          key: this.leadHeaderData.leadRefNo, routeUrl: 'landingPage'
        }, { key: this.IsInstallationDebtor ? 'Sales & Installation Agreement' : 'Service Agreement' }, { key: 'Credit Vetting' }]
      };
    });
    this.getDetails();
    this.createDebterForm();
  }

  getDateFormat() {
    return adjustDateFormatAsPerPCalendar();
  }

  getMonthFormat() {
    return adjustMonthFormatAsPerPCalendar();
  }

  onFormControlChanges() {
    this.creditVettingInfoForm.get('isPassportDebtor').valueChanges.subscribe((isPassportDebtor: boolean) => {
      if (isPassportDebtor) {
        this.creditVettingInfoForm.get('passportNoDebtor').setValidators([Validators.required])
        this.creditVettingInfoForm.get('passportNoDebtor').updateValueAndValidity();
        this.creditVettingInfoForm.get('passportExpiryDateDebt').setValidators([Validators.required])
        this.creditVettingInfoForm.get('passportExpiryDateDebt').updateValueAndValidity({ emitEvent: false });
        this.creditVettingInfoForm.get('saidDebtor').clearValidators();
        this.creditVettingInfoForm.get('saidDebtor').updateValueAndValidity();
        this.creditVettingInfoForm.get('passportExpiryDateDebt').enable({ emitEvent: false });
      } else {
        this.creditVettingInfoForm.get('passportNoDebtor').clearValidators();
        this.creditVettingInfoForm.get('passportNoDebtor').updateValueAndValidity();
        this.creditVettingInfoForm.get('passportExpiryDateDebt').clearValidators();
        this.creditVettingInfoForm.get('passportExpiryDateDebt').updateValueAndValidity({ emitEvent: false });
        this.creditVettingInfoForm.get('saidDebtor').setValidators([Validators.required])
        this.creditVettingInfoForm.get('saidDebtor').updateValueAndValidity();
        this.creditVettingInfoForm.get('passportExpiryDateDebt').disable({ emitEvent: false });
      }
    });
  }

  validate() {
    if (this.details.debtorInformation.debtorTypeId == 1) {
      this.creditVettingInfoForm.get('companyNameDebt').setValidators([Validators.required])
      this.creditVettingInfoForm.get('companyNameDebt').updateValueAndValidity();
      this.creditVettingInfoForm.get('companyRegNoDebt').setValidators([Validators.required])
      this.creditVettingInfoForm.get('companyRegNoDebt').updateValueAndValidity();
    } else {
      this.creditVettingInfoForm.get('companyNameDebt').clearValidators();
      this.creditVettingInfoForm.get('companyNameDebt').updateValueAndValidity();
      this.creditVettingInfoForm.get('companyRegNoDebt').clearValidators();
      this.creditVettingInfoForm.get('companyRegNoDebt').updateValueAndValidity();
    }
  }

  getDetails() {
    this.crudService.get(ModulesBasedApiSuffix.CUSTOMER_MANAGEMENT, SalesModuleApiSuffixModels.CREDIT_VETTING, null, false,
      prepareGetRequestHttpParams(null, null,
        {
          customerId: this.customerId,
          debtorId: this.debtorId,
          debtorAccountDetailId: this.debtorAccountDetailId,
          quotationVersionId: this.serviceAgreementStepsParams.quotationVersionId
        }))
      .subscribe((response: IApplicationResponse) => {
        this.details = response.resources;
        if (this.details) {
          if (this.details.debtorInformation) {
            if (this.details.debtorInformation.passportExpiryDateDebt) {
              this.details.debtorInformation.passportExpiryDateDebt = new Date(this.details.debtorInformation.passportExpiryDateDebt);
            }
            if (this.details.debtorInformation.dob) {
              this.details.debtorInformation.dob = new Date(this.details.debtorInformation.dob);
            }
            if (this.details.debtorInformation.debtorTypeId == 1) {
              this.creditVettingInfoForm.get('companyNameDebt').setValidators([Validators.required])
              this.creditVettingInfoForm.get('companyNameDebt').updateValueAndValidity();
              this.creditVettingInfoForm.get('companyRegNoDebt').setValidators([Validators.required])
              this.creditVettingInfoForm.get('companyRegNoDebt').updateValueAndValidity();
              this.creditVettingInfoForm.get('passportNoDebtor').clearValidators();
              this.creditVettingInfoForm.get('passportNoDebtor').updateValueAndValidity();
              this.creditVettingInfoForm.get('passportExpiryDateDebt').clearValidators();
              this.creditVettingInfoForm.get('passportExpiryDateDebt').updateValueAndValidity({ emitEvent: false });
              this.creditVettingInfoForm.get('saidDebtor').clearValidators();
              this.creditVettingInfoForm.get('saidDebtor').updateValueAndValidity();
              this.creditVettingInfoForm.get('dobDebt').clearValidators();
              this.creditVettingInfoForm.get('dobDebt').updateValueAndValidity();
            } else {
              this.creditVettingInfoForm.get('companyNameDebt').clearValidators();
              this.creditVettingInfoForm.get('companyNameDebt').updateValueAndValidity();
              this.creditVettingInfoForm.get('companyRegNoDebt').clearValidators();
              this.creditVettingInfoForm.get('companyRegNoDebt').updateValueAndValidity();
              this.creditVettingInfoForm.get('passportNoDebtor').setValidators([Validators.required])
              this.creditVettingInfoForm.get('passportNoDebtor').updateValueAndValidity();
              this.creditVettingInfoForm.get('passportExpiryDateDebt').setValidators([Validators.required])
              this.creditVettingInfoForm.get('passportExpiryDateDebt').updateValueAndValidity({ emitEvent: false });
              this.creditVettingInfoForm.get('saidDebtor').setValidators([Validators.required])
              this.creditVettingInfoForm.get('saidDebtor').updateValueAndValidity();
              this.creditVettingInfoForm.get('dobDebt').setValidators([Validators.required])
              this.creditVettingInfoForm.get('dobDebt').updateValueAndValidity();
            }
            if (!this.details.debtorInformation.companyRegNo && !this.details.debtorInformation.said) {
              this.details.debtorInformation.isPassport = true;
            } else {
              this.details.debtorInformation.isPassport = false;
            }
            this.creditVettingInfoForm.patchValue({
              isPassportDebtor: this.details.debtorInformation.isPassport,
              dobDebt: this.details.debtorInformation.dob ? new Date(this.details.debtorInformation.dob) : null,
              passportExpiryDateDebt: this.details.debtorInformation.passportExpiryDate ? new Date(this.details.debtorInformation.passportExpiryDate) : null,
              passportNoDebtor: this.details.debtorInformation.passportNo,
              saidDebtor: this.details.debtorInformation.said,
              systemOwnershipId: this.details.debtorInformation.systemOwnershipId,
              companyNameDebt: this.details.debtorInformation.companyName ? this.details.debtorInformation.companyName : null,
              companyRegNoDebt: this.details.debtorInformation.companyRegNo,
            });
          }
        }
        this.rxjsService.setGlobalLoaderProperty(false);
      });
  }

  createDebterForm() {
    let debtorBankingDetailsModel = new CreditVettingInfo();
    this.creditVettingInfoForm = this.formBuilder.group({});
    Object.keys(debtorBankingDetailsModel).forEach((key) => {
      this.creditVettingInfoForm.addControl(key,
        new FormControl(debtorBankingDetailsModel[key]));
    });
    this.creditVettingInfoForm = setRequiredValidator(this.creditVettingInfoForm, ["dobDebt", "saidDebtor"]);
    this.onFormControlChanges();
  }

  validateDebtor() {
    const dialogReff = this.dialogService.open(CreditVettingModalComponent, { width: '960px', data: this.details.debtorInformation, showHeader: false });
    dialogReff.onClose.subscribe(result => {
      if (typeof result !== 'boolean') {
        this.details.debtorInformation.itNumber = result.itNumber;
      }
    });
  }

  uploadDocument(event: any) {
    this.fileName = '';
    const file = event?.target?.files;
    if (file?.length) {
      const fileObj = file.item(0);
      const fileExtension = fileObj.name.split('.').pop().toLowerCase();
      const fileName = fileObj.name;
      const fileNameCondition = isValidFilename(fileName, { supportedExtensions: this.fileFormats, extension: fileExtension }, { allowedSize: 10 })?.errorMsg;
      if (fileNameCondition) {
        return this.snackbarService.openSnackbar(fileNameCondition);
      }
      this.fileName = fileObj;
      this.onFileUploadAPI();
    }
  }

  onFileUploadAPI() {
    if (this.fileName?.name) {
      let reqObj = {
        customerId: this.customerId,
        addressId: this.serviceAgreementStepsParams?.addressId,
        debtorAdditionalInfoId: this.serviceAgreementStepsParams?.debtorAdditionalInfoId,
        quotationVersionId: this.serviceAgreementStepsParams?.quotationVersionId,
        createdUserId: this.loggedInUserData?.userId,
      }
      let formData = new FormData();
      formData.append("file", this.fileName);
      formData.append('Obj', JSON.stringify(reqObj));
      this.rxjsService.setGlobalLoaderProperty(true);
      this.crudService.create(ModulesBasedApiSuffix.CUSTOMER_MANAGEMENT, SalesModuleApiSuffixModels.CREDIT_VETTING_DOCUMENT, formData)
        .subscribe((response: IApplicationResponse) => {
          if (response.isSuccess && response.statusCode == 200) {
            this.back();
          }
          this.fileName = '';
          this.fileInput.nativeElement.value = '';
          this.rxjsService.setGlobalLoaderProperty(false);
        });
    } else {
      this.snackbarService.openSnackbar("Please select a file to upload");
    }
  }

  onSubmit() {
    this.validate();
    this.rxjsService.setFormChangeDetectionProperty(true);
    if (this.details.debtorInformation.debtorTypeId == 1) {
      this.creditVettingInfoForm.get('saidDebtor').setValue(this.creditVettingInfoForm.value.companyRegNoDebt)
    }
    if (this.creditVettingInfoForm.invalid) {
      return;
    }
    if (this.details.debtorInformation.debtorTypeId == 1) {
      if (!this.details.debtorInformation.itNumber) {
        this.snackbarService.openSnackbar("Please click Validate debtor to get IT number before proceeding credit vetting", ResponseMessageTypes.ERROR);
        return;
      }
    }
    if (this.creditVettingInfoForm.value.isPassportDebtor) {
      this.creditVettingInfoForm.get('saidDebtor').setValue(null)
    } else {
      this.creditVettingInfoForm.get('passportNoDebtor').setValue(null)
      this.creditVettingInfoForm.get('passportExpiryDateDebt').setValue(null)
    }
    let data = this.creditVettingInfoForm.getRawValue();
    let obj = {
      'debtorInformation': {},
      'debtorBankingInformation': {},
      debtorAdditionalInfoId: this.serviceAgreementStepsParams?.debtorAdditionalInfoId,
      'createdUserId': this.loggedInUserData.userId
    };
    obj.debtorInformation = {
      "debtorId": this.debtorId,
      "customerId": this.details.debtorInformation ? this.details.debtorInformation.customerId : null,
      "leadId": this.details.debtorInformation ? this.details.debtorInformation.leadId : null,
      "debtorRefNo": this.details.debtorInformation ? this.details.debtorInformation.debtorRefNo : null,
      "debtorName": this.details.debtorInformation ? this.details.debtorInformation.debtorName : null,
      "debtorType": this.details.debtorInformation ? this.details.debtorInformation.debtorType : null,
      "itNumber": this.details.debtorInformation ? this.details.debtorInformation.itNumber : null,
      "systemOwnershipId": this.details.debtorInformation ? this.details.debtorInformation.systemOwnershipId : null,
      "customerAddress": this.details.debtorInformation ? this.details.debtorInformation.customerAddress : null,
      "firstName": this.details.debtorInformation ? this.details.debtorInformation.firstName : null,
      "lastName": this.details.debtorInformation ? this.details.debtorInformation.lastName : null,
      "said": !data.passportNoDebtor && data.saidDebtor ? data.saidDebtor : null,
      "mobile1": this.details.debtorInformation ? this.details.debtorInformation.mobile1 : '',
      "mobile1CountryCode": this.details.debtorInformation ? this.details.debtorInformation.mobile1CountryCode : '',
      "officeNo": null,
      "officeNoCountryCode": null,
      "foreName1": this.details.debtorInformation ? this.details.debtorInformation.foreName1 : null,
      "foreName2": this.details.debtorInformation ? this.details.debtorInformation.foreName2 : null,
      "buildingNumber": this.details.debtorInformation ? this.details.debtorInformation.buildingNumber : null,
      "streetNumber": this.details.debtorInformation ? this.details.debtorInformation.streetNumber : null,
      "isPassport": data.isPassportDebtor,
      "dob": data.dobDebt ? datePipeConversion(data.dobDebt, SERVER_REQUEST_DATE_TRANSFORM) : null,
      "passportNo": data.passportNoDebtor && data.isPassportDebtor ? data.passportNoDebtor : null,
      "companyName": data.companyNameDebt,
      "companyRegNo": data.companyRegNoDebt,
      'passportExpiryDate': data.passportExpiryDateDebt && data.isPassportDebtor ? datePipeConversion(data.passportExpiryDateDebt, SERVER_REQUEST_DATE_TRANSFORM) : null,
      "debtorTypeId": this.details.debtorInformation ? this.details.debtorInformation.debtorTypeId : null,
      "isDebtorSameAsCustomer": this.details.debtorInformation ? this.details.debtorInformation.isDebtorSameAsCustomer : false,
      'systemOwnership': data.systemOwnership,
      "isDebtorVetted": this.details.debtorInformation ? this.details.debtorInformation.isDebtorVetted : false,
    }
    obj.debtorBankingInformation = {
      "accountHolderName": this.details.debtorBankingInformation ? this.details.debtorBankingInformation.accountHolderName : null,
      "companyName": this.details.debtorBankingInformation ? this.details.debtorBankingInformation.companyName : null,
      "isBankAccount": this.details.debtorBankingInformation ? this.details.debtorBankingInformation.isBankAccount : false,
      "bankName": this.details.debtorBankingInformation ? this.details.debtorBankingInformation.bankName : null,
      "bankBranchName": this.details.debtorBankingInformation ? this.details.debtorBankingInformation.bankBranchName : null,
      "bankBranchCode": this.details.debtorBankingInformation ? this.details.debtorBankingInformation.bankBranchCode : null,
      "accountNo": this.details.debtorBankingInformation ? this.details.debtorBankingInformation.accountNo : null,
      "accountTypeName": this.details.debtorBankingInformation ? this.details.debtorBankingInformation.accountTypeName : null,
      "cardNo": this.details.debtorBankingInformation ? this.details.debtorBankingInformation.cardNo : null,
      "expiryDate": this.details.debtorBankingInformation ? this.details.debtorBankingInformation.expiryDate : null,
      "cardTypeName": this.details.debtorBankingInformation ? this.details.debtorBankingInformation.cardTypeName : null,
      "accountTypeDescription": this.details.debtorBankingInformation ? this.details.debtorBankingInformation.accountTypeDescription : null,
      "accountTypeId": this.details.debtorBankingInformation ? this.details.debtorBankingInformation.accountTypeId : null,
      "isDebtorAccountVetted": this.details.debtorBankingInformation ? this.details.debtorBankingInformation.isDebtorAccountVetted : false,
      "debtorAccountDetailId": this.details.debtorBankingInformation ? this.details.debtorBankingInformation.debtorAccountDetailId : null,
    }
    if (this.details?.debtorInformation?.debtorTypeId == this.debtorTypeEnum.LEGAL_ENTITY) {
      obj.debtorBankingInformation['accountOwnerCompanyRegNo'] = this.details?.debtorBankingInformation?.accountOwnerCompanyRegNo;
    }
    if (this.details?.debtorInformation?.debtorTypeId == this.debtorTypeEnum.PERSON) {
      obj.debtorBankingInformation['accountOwnerSAID'] = this.details?.debtorBankingInformation?.accountOwnerSAID;
    }
    let formData = new FormData();
    formData.append('data', JSON.stringify(obj));
    this.crudService.create(ModulesBasedApiSuffix.CUSTOMER_MANAGEMENT, SalesModuleApiSuffixModels.CREDIT_VETTING_V1, formData)
      .subscribe((response: IApplicationResponse) => {
        if (response.isSuccess && response.statusCode == 200) {
          this.successMsg = true;
          this.createDebterForm();
          this.getDetails();
        }
      });
  }

  redirectToDebtorBankingDetails() {
    let queryParams = { queryParams: { customerId: this.leadHeaderData.customerId, debtorId: this.serviceAgreementStepsParams.debtorId, debtorAccountDetailId: this.details?.debtorBankingInformation?.debtorAccountDetailId } };
    let urlSuffix = this.IsInstallationDebtor ? 'installation-agreement/credit-vetting-result' :
      'service-agreement/credit-vetting-result';
    if (this.leadHeaderData.fromUrl == 'Leads List') {
      this.router.navigate([`/sales/task-management/leads/${urlSuffix}`], queryParams);
    }
    else {
      this.router.navigate([`/my-tasks/my-sales/my-leads/${urlSuffix}`], queryParams);
    }
  }

  back() {
    let queryParams = { queryParams: { customerId: this.leadHeaderData.customerId, debtorId: this.serviceAgreementStepsParams.debtorId, debtorAccountDetailId: this.details.debtorBankingInformation?.debtorAccountDetailId } };
    let urlSuffix = this.IsInstallationDebtor ? 'installation-agreement/debtor-banking-details' :
      'service-agreement/debtor-banking-details';
    if (this.serviceAgreementStepsParams.isOnInvoicePayment) {
      urlSuffix = this.IsInstallationDebtor ? 'installation-agreement/debtor-creation' :
        'service-agreement/debtor-creation';
    }
    if (this.leadHeaderData.fromUrl == 'Leads List') {
      this.router.navigate([`/sales/task-management/leads/${urlSuffix}`], queryParams);
    }
    else {
      this.router.navigate([`/my-tasks/my-sales/my-leads/${urlSuffix}`], queryParams);
    }
  }

  cancel() {
    this.successMsg = false;
  }
}
